import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import TRANSLATIONS_LS_CACHE_KEYS from 'tbase/constants/translationsLSCacheKeys';
import { getValueFromLocalStorage, removeValueFromLocalStorage } from './localStorage';
import { getValueFromSessionStorage, setValueInSessionStorage, removeValueFromSessionStorage } from './sessionStorage';
export var DEALER_CONTEXT_QUERY_PARAM_KEYS = {
  DEALER_ID: 'currentTabSessionDealerId',
  TEK_SITE_ID: 'currentTabSessionTekSiteId',
  ROLE_ID: 'currentTabSessionRoleId',
  WORKSPACE_ID: 'currentTabSessionWorkspaceId',
  IS_WORKSPACE: 'isCurrentTabSessionWorkspace'
};
export var isAuthenticated = function isAuthenticated() {
  var token = getValueFromLocalStorage('t_token');
  var userDetails = getValueFromLocalStorage('t_user');
  var dseUserDetails = getValueFromLocalStorage('dse_t_user');
  return !(!token || _isEmpty(userDetails) || _isEmpty(dseUserDetails));
};
export var isContextValid = function isContextValid() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      dealerId = _ref.dealerId,
      tekSiteId = _ref.tekSiteId,
      roleId = _ref.roleId,
      workspaceId = _ref.workspaceId,
      isWorkspace = _ref.isWorkspace;

  var isDealerContextValid = !_isNil(dealerId) && !_isNil(tekSiteId) && !_isNil(roleId);
  var isWorkspaceContextValid = (isWorkspace === true || isWorkspace === 'true') && !_isNil(workspaceId) && !_isNil(roleId);
  return isWorkspaceContextValid || isDealerContextValid;
}; // URL copy paste -> we should get info from active Tab

export var getDealerContextFromPreviousActiveTab = function getDealerContextFromPreviousActiveTab() {
  var currentActiveDealerId = getValueFromLocalStorage('currentActiveDealerId');
  var currentActiveSiteId = getValueFromLocalStorage('currentActiveSiteId');
  var currentActiveRoleId = getValueFromLocalStorage('currentActiveRoleId');
  var currentActivePersona = getValueFromLocalStorage('currentActivePersona');
  var currentActiveWorkspace = getValueFromLocalStorage('currentActiveWorkspace');
  var currentActiveIsWorkspace = getValueFromLocalStorage('currentActiveIsWorkspace');
  var currentActiveLocale = getValueFromLocalStorage('currentActiveLocale');
  return {
    dealerId: currentActiveDealerId,
    tekSiteId: currentActiveSiteId,
    roleId: currentActiveRoleId,
    persona: currentActivePersona,
    workspaceId: currentActiveWorkspace,
    isWorkspace: currentActiveIsWorkspace,
    currentLocale: currentActiveLocale
  };
};
export var getDealerContextFromQueryParams = function getDealerContextFromQueryParams() {
  var queryParams = new URLSearchParams(window.location.search);
  return {
    dealerId: queryParams.get(DEALER_CONTEXT_QUERY_PARAM_KEYS.DEALER_ID),
    tekSiteId: queryParams.get(DEALER_CONTEXT_QUERY_PARAM_KEYS.TEK_SITE_ID),
    roleId: queryParams.get(DEALER_CONTEXT_QUERY_PARAM_KEYS.ROLE_ID),
    workspaceId: queryParams.get(DEALER_CONTEXT_QUERY_PARAM_KEYS.WORKSPACE_ID),
    isWorkspace: queryParams.get(DEALER_CONTEXT_QUERY_PARAM_KEYS.IS_WORKSPACE)
  };
};
export var getDealerContextFromSessionStorage = function getDealerContextFromSessionStorage() {
  var persona = getValueFromSessionStorage('persona');
  var dealerId = getValueFromSessionStorage('dealerId');
  var tekSiteId = getValueFromSessionStorage('tekSiteId');
  var roleId = getValueFromSessionStorage('roleId');
  var workspaceId = getValueFromSessionStorage('workspaceId');
  var isWorkspace = getValueFromSessionStorage('isWorkspace');
  var sessionContext = {
    roleId: roleId
  };
  if (!(!dealerId || dealerId === 'null')) sessionContext = _objectSpread(_objectSpread({}, sessionContext), {}, {
    dealerId: dealerId
  });
  if (!(!workspaceId || workspaceId === 'null')) sessionContext = _objectSpread(_objectSpread({}, sessionContext), {}, {
    workspaceId: workspaceId
  });
  if (!(!tekSiteId || tekSiteId === 'null')) sessionContext = _objectSpread(_objectSpread({}, sessionContext), {}, {
    tekSiteId: tekSiteId
  });
  if (!(!isWorkspace || isWorkspace === 'null')) sessionContext = _objectSpread(_objectSpread({}, sessionContext), {}, {
    isWorkspace: isWorkspace
  });
  if (!(!persona || persona === 'null')) sessionContext = _objectSpread(_objectSpread({}, sessionContext), {}, {
    persona: persona
  });
  return sessionContext;
};
export var getDealerContextWithFallback = function getDealerContextWithFallback() {
  var overideDealerContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = [getDealerContextFromQueryParams(), getDealerContextFromSessionStorage(), getDealerContextFromPreviousActiveTab()],
      queryParamsDealerContext = _ref2[0],
      sessionDealerContext = _ref2[1],
      previousActiveTabDealerContext = _ref2[2];
  if (isContextValid(queryParamsDealerContext)) return queryParamsDealerContext;
  if (isContextValid(sessionDealerContext)) return sessionDealerContext;
  if (isContextValid(previousActiveTabDealerContext)) return previousActiveTabDealerContext;
  if (isContextValid(overideDealerContext)) return overideDealerContext;
  return {};
};
export var setDealerPersonaContext = function setDealerPersonaContext(persona) {
  return setValueInSessionStorage('persona', persona);
};
export var setDealerContext = function setDealerContext() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      dealerId = _ref3.dealerId,
      tekSiteId = _ref3.tekSiteId,
      roleId = _ref3.roleId,
      persona = _ref3.persona,
      workspaceId = _ref3.workspaceId,
      isWorkspace = _ref3.isWorkspace;

  if (!isContextValid({
    dealerId: dealerId,
    tekSiteId: tekSiteId,
    roleId: roleId,
    workspaceId: workspaceId,
    isWorkspace: isWorkspace
  })) return;
  if (dealerId) setValueInSessionStorage('dealerId', dealerId);
  if (tekSiteId) setValueInSessionStorage('tekSiteId', tekSiteId);
  setValueInSessionStorage('roleId', roleId);
  if (workspaceId) setValueInSessionStorage('workspaceId', workspaceId);
  if (isWorkspace) setValueInSessionStorage('isWorkspace', isWorkspace);
  if (persona) setDealerPersonaContext(persona);
};
export var setDealerContextByQueryParams = function setDealerContextByQueryParams(_ref4) {
  var dealerId = _ref4.dealerId,
      tekSiteId = _ref4.tekSiteId,
      roleId = _ref4.roleId,
      workspaceId = _ref4.workspaceId,
      isWorkspace = _ref4.isWorkspace;

  var _getDealerContextFrom = getDealerContextFromQueryParams(),
      queryParamDealerId = _getDealerContextFrom.dealerId,
      queryParamTekSiteId = _getDealerContextFrom.tekSiteId,
      queryParamRoleId = _getDealerContextFrom.roleId,
      queryParamWorkspaceId = _getDealerContextFrom.workspaceId,
      queryParamIsWorkspace = _getDealerContextFrom.isWorkspace;

  if (isContextValid({
    dealerId: dealerId,
    tekSiteId: tekSiteId,
    roleId: roleId,
    workspaceId: workspaceId,
    isWorkspace: isWorkspace
  })) return setDealerContext({
    dealerId: dealerId,
    tekSiteId: tekSiteId,
    roleId: roleId,
    workspaceId: workspaceId,
    isWorkspace: isWorkspace
  });
  return setDealerContext({
    dealerId: queryParamDealerId,
    siteId: queryParamTekSiteId,
    roleId: queryParamRoleId,
    workspaceId: queryParamWorkspaceId,
    isWorkspace: queryParamIsWorkspace
  });
};
export var setDealerContextWithFallback = function setDealerContextWithFallback(overideDealerContext) {
  var _ref5 = [getDealerContextFromQueryParams(), getDealerContextFromSessionStorage(), getDealerContextFromPreviousActiveTab()],
      queryParamsDealerContext = _ref5[0],
      sessionDealerContext = _ref5[1],
      previousActiveTabDealerContext = _ref5[2];
  if (isContextValid(queryParamsDealerContext)) return setDealerContext(queryParamsDealerContext);
  if (isContextValid(sessionDealerContext)) return setDealerContext(sessionDealerContext);
  if (isContextValid(previousActiveTabDealerContext)) return setDealerContext(previousActiveTabDealerContext);
  if (isContextValid(overideDealerContext)) return setDealerContext(overideDealerContext);
  return undefined;
};
export var clearDealerContext = function clearDealerContext() {
  removeValueFromSessionStorage('dealerId');
  removeValueFromSessionStorage('tekSiteId');
  removeValueFromSessionStorage('roleId');
  removeValueFromSessionStorage('persona');
  removeValueFromSessionStorage('isWorkspace');
  removeValueFromSessionStorage('workspaceId');
  removeValueFromLocalStorage('currentActiveDealerId');
  removeValueFromLocalStorage('currentActiveSiteId');
  removeValueFromLocalStorage('currentActiveRoleId');
  removeValueFromLocalStorage('currentActivePersona');
  removeValueFromLocalStorage('currentActiveWorkspace');
  removeValueFromLocalStorage('currentActiveIsWorkspace');
  removeValueFromLocalStorage('currentActiveLocale');
};